"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionsComponent = void 0;
const core_1 = require("@angular/core");
const moment_1 = __importDefault(require("moment"));
const enums_1 = require("../@shared-types/tenant/enums");
const transaction_1 = __importDefault(require("../shared/models/transaction"));
let TransactionsComponent = class TransactionsComponent {
    constructor(transactionModel) {
        this.transactionModel = transactionModel;
        this.transactions = null;
        this.monthlyBill = null;
        this.sumsTransactionsMonth = 0;
        this.nextBillingDate = (0, moment_1.default)().add(1, 'month').startOf('month').format('DD.MM.YYYY');
        /** Some transactions might be deleted or altered before displaying.
         * When a vehicle sale is removed within 7 days, the sale transaction will be skipped. */
        this.prepareTransactions = (transactions) => {
            const filteredTransactions = [...transactions];
            const transactionsToRemove = [];
            transactions
                .filter((t) => t.type === enums_1.EFeatures.VEHICLE_REMOVE_SALE)
                .forEach((removedSale) => {
                transactionsToRemove.push(removedSale.id);
                /** Try to find a vehicle sale, that corresponds to this sale removal */
                filteredTransactions
                    .filter((t) => {
                    if (t.contextId !== removedSale.contextId)
                        return false;
                    if (t.type !== enums_1.EFeatures.VEHICLE_SALE)
                        return false;
                    // if (moment(t.date).isAfter(removedSale.date)) return false;
                    // if (moment(t.date).isBefore(moment(removedSale.date).subtract(7, 'd'))) return false;
                    return true;
                })
                    .forEach((s) => transactionsToRemove.push(s.id));
            });
            return filteredTransactions.filter((f) => !transactionsToRemove.includes(f.id));
        };
        /** The server returns an array of all transactions, that will be used to bill
         * a tenant. Here we will sort the transactions by month and show the count of
         * transactions by type. */
        this.initTransaction = () => __awaiter(this, void 0, void 0, function* () {
            this.monthlyBill = yield this.transactionModel.getBillable();
            this.transactions = [];
            const transactions = this
                .prepareTransactions(this.monthlyBill.transactions)
                .filter((t) => (0, moment_1.default)(t.date).isAfter((0, moment_1.default)().subtract(6, 'month').startOf('month')));
            this.sumsTransactionsMonth = 0;
            const transactionTypes = [...new Set(transactions.map((t) => t.type))];
            const transactionMonths = [...new Set(transactions.map((t) => (0, moment_1.default)(t.date).get('month')))].reverse();
            transactionMonths.forEach((transactionMonth) => {
                var _a;
                const month = {
                    dateStart: (0, moment_1.default)().set('month', transactionMonth).startOf('month').format('DD.MM'),
                    dateEnd: (0, moment_1.default)().set('month', transactionMonth).endOf('month').format('DD.MM'),
                    billableTransactions: [],
                    currentMonth: (0, moment_1.default)().get('month') === transactionMonth,
                };
                transactionTypes.forEach((type) => {
                    const transactionsByType = transactions.filter((t) => (t.type === type) && (0, moment_1.default)(t.date).get('month') === transactionMonth);
                    const t = {
                        count: transactionsByType.length,
                        title: this.transactionModel.translateType(type),
                        transactions: transactionsByType,
                        sum: transactionsByType.reduce((a, b) => a + b.price, 0),
                    };
                    month.billableTransactions.push(t);
                    if (month.currentMonth)
                        this.sumsTransactionsMonth += t.sum;
                });
                (_a = this.transactions) === null || _a === void 0 ? void 0 : _a.push(month);
            });
        });
        this.initTransaction();
    }
};
TransactionsComponent = __decorate([
    (0, core_1.Component)({
        selector: 'transactions',
        templateUrl: require('./transactions.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof transaction_1.default !== "undefined" && transaction_1.default) === "function" ? _a : Object])
], TransactionsComponent);
exports.TransactionsComponent = TransactionsComponent;
